/**
 * <ReferralLinkRow> — copyable referral URL row (molecule, L0.1).
 *
 * Shows a brief "Copié !" flash after copy so callers need no SnackBar.
 */
import { useEffect, useState } from "react"
import { StyleSheet } from "react-native-unistyles"

import { Icon } from "../../atoms/icons/Icon"
import { Row } from "../../atoms/containers/Row"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../Card"

export type ReferralLinkRowProps = {
    url: string
    onCopyLink?: () => void
    testID?: string
}

export function ReferralLinkRow(props: ReferralLinkRowProps) {
    const { url, onCopyLink, testID } = props
    const [copied, setCopied] = useState(false)

    useEffect(() => {
        if (!copied) return
        const id = setTimeout(() => setCopied(false), 2000)
        return () => clearTimeout(id)
    }, [copied])

    const handleCopy = () => {
        onCopyLink?.()
        setCopied(true)
    }

    // One touch target for the whole row (as legacy): the trailing glyph is an affordance, not a
    // nested button — stacking pressables is unreliable on Android.
    return (
        <Card p="3" background="surface" pressable onPress={handleCopy} testID={testID}>
            <Row align="center" gap="3">
                <Icon name="link" size={14} color="text-muted" />
                <Text size="text-sm" numberOfLines={1} style={styles.url}>
                    {copied ? "Copié !" : url}
                </Text>
                <Icon name="copy" size={16} color="primary" />
            </Row>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    url: {
        flex: 1,
        flexShrink: 1,
    },
}))
